// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"412":"b83bc17f","916":"3c917b86"}[chunkId] + ".chunk.css";
};